import React from 'react';
import { Edit3, Upload } from 'lucide-react';

const ViewModeToggle = ({ mode, onModeChange }) => {
  return (
    <div className="view-mode-toggle flex gap-1 bg-gray-100 dark:bg-gray-700 rounded-lg p-1">
      <button
        onClick={() => onModeChange('manage')}
        className={`flex items-center gap-2 px-3 py-1.5 rounded transition-colors ${
          mode === 'manage'
            ? 'bg-white dark:bg-gray-800 text-blue-600 dark:text-blue-400 shadow-sm'
            : 'text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200'
        }`}
        title="Manage Mode - Edit and manage your quotes"
      >
        <Edit3 size={16} />
        <span className="text-sm font-medium hidden sm:inline">Manage</span>
      </button>
      <button
        onClick={() => onModeChange('integrations')}
        className={`flex items-center gap-2 px-3 py-1.5 rounded transition-colors ${
          mode === 'integrations'
            ? 'bg-white dark:bg-gray-800 text-blue-600 dark:text-blue-400 shadow-sm'
            : 'text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200'
        }`}
        title="Integrations - Import new quotes from various sources"
      >
        <Upload size={16} />
        <span className="text-sm font-medium hidden sm:inline">Integrations</span>
      </button>
    </div>
  );
};

export default ViewModeToggle;
